<style lang="scss" scoped>
.slide-9 {
  background-image: url(../../../assets/module4/slide9/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 88px;
  padding-left: 100px;
  padding-right: 100px;
  height: calc(100% - 88px);
}
.left {
  width: 700px;
}
h1 {
  font-size: 55px;
  transform: rotate(-5deg);
  span {
    color: #68388d;
  }
}
.cutout {
  float: left;
  shape-outside: polygon(0 0, 0 100px, 1200px 1200px);
  width: 400px;
  height: 400px;
}
.drag-btns {
  // width: 611px;
  // margin-left: 100px;
  display: flex;
  width: 30%;
  flex-wrap: wrap;
  justify-content: space-around;
  top: 638px;
  position: absolute;
}
.drag-item {
  height: 61px;
  width: 200px;
  background-image: url("../../../assets/module4/slide9/time.png");
  background-size: 100% 100%;
  font-size: 27px;
  font-family: "Kookycat-FASTcaps";
  color: white;
  line-height: 60px;
  text-align: center;
  touch-action: none;
  position: relative;
  z-index: 10;
  display: inline-block;
  margin-bottom: 15px;
  &:first-of-type {
    transform: translate(100px, 1px) rotate(1deg);
    color: #edad0a;
  }
  &:nth-of-type(2) {
    transform: rotate(11deg) translate(50px, 0px);
    color: #ed8595;
  }
  &:nth-of-type(3) {
    transform: translate(140px, 20px) rotate(-11deg);
    color: #68388c;
  }
  &:nth-of-type(4) {
    transform: rotate(-5deg) translate(0, 80px);
    color: #c5d53b;
  }
}
.drag {
  width: 212px;
  height: 212px;
  background-image: url(../../../assets/module1/slide4/drag_drop.svg);
  background-position: center;
  background-size: 160%;
  background-repeat: no-repeat;
  margin-left: 60px;
  margin-right: 20px;
}
.download {
  width: 200px;
  height: 200px;
  background-image: url(../../../assets/module4/slide9/dowload_share.png);
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: 35px;
  transition: all 0.2s ease-out;
  transform: translateY(-10px);
  &:hover {
    transform: translateY(-10px) scale(1.1);
  }
}
.lb {
  width: 450px;
}
.flex {
  height: auto;
  align-items: center;
}
p {
  margin: 0;
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
#pdfDocument {
  width: 1px;
  height: 1px;
  visibility: hidden;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 100px;
  right: 100px;
}
</style>

<template>
  <div class="slide-9">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module4/slide9/nursery ryhme-04.png"
        class="chars delay-3"
        v-show="slideIndex == 8"
      />
    </transition>

    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module4/slide9/shophia-01.png"
        class="chars"
        v-show="slideIndex == 8"
      />
    </transition>
    <div class="left">
      <transition name="scale" appear>
        <div v-show="slideIndex == 8" class="delay-1">
          <h1>
            One of my favourite things in the world is to read poems, so I wrote
            a
            <div class="cutout"></div>
            <span>very special poem just for</span> you but some of the words
            are&nbsp;missing.
          </h1>
        </div>
      </transition>
      <transition name="scale" appear>
        <div class="drag-btns delay-2" v-show="slideIndex == 8">
          <div class="drag-item" v-drag data-drop-x="1350" data-drop-y="-14">
            TIME!
          </div>
          <div class="drag-item" v-drag data-drop-x="1095" data-drop-y="-130">
            SPEECH!
          </div>
          <div class="drag-item" v-drag data-drop-x="1340" data-drop-y="-323">
            ARM!
          </div>
          <div class="drag-item" v-drag data-drop-x="1220" data-drop-y="-440">
            FACE!
          </div>
        </div>
      </transition>
    </div>
    <transition name="fadeUp" appear>
      <div class="flex delay-4 footer" v-show="slideIndex == 8">
        <div class="drag"></div>
        <div class="lb">
          <p>See if you can drag the missing words into the right place.</p>
        </div>
        <a :href="pdfLink" class="download" target="_blank"></a>
        <div class="lb">
          <p>
            You can download the poem once you’ve got it right and email it to
            your Grandhero.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  data: function() {
    return {
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_1?.url ||
        "../Week-4-Activity-Card-COLOUR-Asset-28.pdf",
      pdfId:
        window?.CF_EBOOK_VARS?.documents?.book_4_document_1?.document_id ||
        "4584",
      points: 0,
      showVid: false
    };
  },
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
